import { FC } from "react";
import ReviewsList from "@/components/Reviews/ReviewsList";
import ReviewsSlider from "@/components/Reviews/ReviewsSlider";
import useIsMobile from "@/custom_hooks/isMobile";

interface ReviewsProps {
  className?: string;
  type?: "slider" | "loadableList";
}

const ReviewsComponent: FC<ReviewsProps> = ({ className, type = "slider" }) => {
  const isMobile = useIsMobile();

  return (
    <div className={className}>
      {(type === "slider" || isMobile) && <ReviewsSlider />}
      {type === "loadableList" && !isMobile && <ReviewsList />}
    </div>
  );
};

export default ReviewsComponent;
